import React, { Component } from 'react';

class LabelRelease extends Component {
    onClickBuy(e) {
        e.stopPropagation();
        window.open("https://www.discogs.com/sell/release/" + this.props.release.id, "_blank");
        return false;
    }
    
    render() {
        return (
            <div onClick={this.props.onClick} className="youtube-result discogs-result">
              {this.props.release.thumb !== '' ? <img className="youtube-result-thumbnail" src={this.props.release.thumb}/> : ''}
              <div className="discogs-result-title">{this.props.release.artist} - {this.props.release.title} ({this.props.release.year})</div>

              <div
                onClick={(e) => this.onClickBuy(e)}
                className="discogs-result-url">
                Buy Vinyl
              </div>
            </div>);
    }
}
 
export default LabelRelease;
